import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { ScannerFormState } from '../../../_state/scannerForm.state';
import { ScannerDetailRecord } from '../../../types/sidecar';

import { ScannerFormFields } from './ScannerFormFields';
import { ScannerFormFooterActions } from './ScannerFormFooterActions';

import { useScannerLocalClient } from '~/shared/providers/libp2p/useScannerLocalClient';

type Props = {
  scanner?: ScannerDetailRecord | null;
  scannerId?: string;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: ScannerFormState) => void;
  isSaving?: boolean;
};

type LocalScannerInfo = {
  manufacturer: string;
  model: string;
  firmwareVersion: string;
} | null;

export const ScannerTabInfo: React.FC<Props> = ({
  scanner,
  scannerId,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => {
  const scannerClient = useScannerLocalClient(scanner?.sidecarId ?? '');

  const [localScannerInfo, setLocalScannerInfo] =
    React.useState<LocalScannerInfo>(null);

  React.useEffect(() => {
    if (!scannerClient || !scannerId) {
      setLocalScannerInfo(null);
      return;
    }

    let cancelled = false;

    scannerClient
      .getScannerInfo({ scannerId })
      .then((res) => {
        if (cancelled || !res.scanner) return;
        setLocalScannerInfo({
          manufacturer: res.scanner.manufacturer,
          model: res.scanner.model,
          firmwareVersion: res.scanner.firmwareVersion,
        });
      })
      .catch(() => {
        if (!cancelled) {
          setLocalScannerInfo(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [scannerClient, scannerId]);

  return (
    <div className="@ScannerTabInfo flex max-h-full flex-col gap-5 p-5">
      <ContentCard className="p-0 pt-5">
        <ScannerFormFields
          scanner={scanner}
          scannerId={scannerId}
          localScannerInfo={localScannerInfo}
        />
        <ScannerFormFooterActions
          onSaveUpdates={onSaveUpdates}
          onDiscard={onDiscard}
          isSaving={isSaving}
        />
      </ContentCard>
    </div>
  );
};
